<script>
  import { getBoolean, i18n, localizeUri } from '@/commons/utils';
  import { levelSliding } from './nav-utils.js';
  import { onMount } from 'svelte';
  import AllSports from './AllSports.svelte';
  import SubLevel from './SubLevel.svelte';
  import Footer from './Footer.svelte';
  import SvgIcon from './SvgIcon.svelte';

  export let json = {};
  export let storeInfos = {};
  export let defaultSport;
  export let backgroundSrc;
  export let displayedSubLevel = defaultSport ? 'allSports' : null;

  const displaySportsInGridLayout = false;
  let showAllSports = false;

  $: MenuTitle =
    json.SportCategories &&
    json.SportCategories.replaceMenauSportTitleTranslationKey !== '' &&
    json.SportCategories.replaceMenauSportTitleTranslationKey !==
      i18n(json.SportCategories.replaceMenauSportTitleTranslationKey)
      ? i18n(json.SportCategories.replaceMenauSportTitleTranslationKey)
      : `${json.SportCategories.categoryList.length} ${i18n('navigation.sports')}`;

  onMount(() => {
    cube.lazyload.updateObserver();
  });

  const closeSubMenu = () => {
    displayedSubLevel = null;
    defaultSport = '';
  };
</script>

<style type="less">/*     Links     */
/*     Main colors     */
/*     Forms     */
/* tiny font sizes (mobile first) */
/* font-weights */
/* font-weights china limits */
/* Path */
/* Font families */
/* Default font stacks */
/* Chinese font stacks */
/* Breakpoints */
/* === ============= === */
/* VARS */
/*== Colors
//
//## Gray and brand colors for use across Bootstrap. */
/*== Scaffolding
//
//## Settings for some of the most global styles. */
/* Background color for `<body>`. */
/* Global text color on `<body>`. */
/* Global textual link color. */
/* Link hover color set via `darken()` function. */
/* Link hover decoration.alert */
/*== Typography
//
//## Font, line-height, and color for body text, headings, and more. */
/* Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`. */
/* Unit-less `line-height` for use in components like buttons. */
/* Computed "line-height" (`font-size` * `line-height`) for use with `margin`, `padding`, etc. */
/* By default, this inherits from the `<body>`. */
/*== Iconography
//
//## Specify custom location and filename of the included Glyphicons icon font. Useful for those including Bootstrap via Bower. */
/* Load fonts from this directory. */
/* File name for all font files. */
/* Element ID within SVG icon file. */
/*== Components
//
//## Define common padding and border radius sizes and more. Values based on 14px text and 1.428 line-height (~20px to start). */
/* Global color for active items (e.g., navs or dropdowns). */
/* Global background color for active items (e.g., navs or dropdowns). */
/* Width of the `border` for generating carets that indicator dropdowns. */
/* Carets increase slightly in size for larger components. */
/*== Tables
//
//## Customizes the `.table` component with basic values, each used across all table variations. */
/* Padding for `<th>`s and `<td>`s. */
/* Padding for cells in `.table-condensed`. */
/* Default background color used for all tables. */
/* Background color used for `.table-striped`. */
/* Background color used for `.table-hover`. */
/* Border color for table and cell borders. */
/*== Buttons
//
//## For each of Bootstrap's buttons, define text, background and border color. */
/* Allows for customizing button radius independently from global border radius */
/*== Forms
//
//## */
/* `<input>` background color */
/* `<input disabled>` background color */
/* Text color for `<input>`s */
/* `<input>` border color */
/* TODO: Rename `@input-border-radius` to `@input-border-radius-base` in v4 */
/* Default `.form-control` border radius */
/* This has no effect on `<select>`s in some browsers, due to the limited stylability of `<select>`s in CSS. */
/* Large `.form-control` border radius */
/* Small `.form-control` border radius */
/* Border color for inputs on focus */
/* Placeholder text color */
/* Default `.form-control` height */
/* Large `.form-control` height */
/* Small `.form-control` height */
/* `.form-group` margin */
/* Background color for textual input addons */
/* Border color for textual input addons */
/* Disabled cursor for form controls and buttons. */
/*== Dropdowns
//
//## Dropdown menu container and contents. */
/* Background for the dropdown menu. */
/* Dropdown menu `border-color`. */
/* Dropdown menu `border-color` **for IE8**. */
/* Divider color for between dropdown items. */
/* Dropdown link text color. */
/* Hover color for dropdown links. */
/* Hover background for dropdown links. */
/* Active dropdown menu item text color. */
/* Active dropdown menu item background color. */
/* Disabled dropdown menu item background color. */
/* Text color for headers within dropdown menus. */
/* Deprecated `@dropdown-caret-color` as of v3.1.0 */
/*-- Z-index master list
//
// Warning: Avoid customizing these values. They're used for a bird's eye view
// of components dependent on the z-axis and are designed to all work together.
//
// Note: These variables are not generated into the Customizer. */
/*== Media queries breakpoints
//
//## Define the breakpoints at which your layout will change, adapting to different screen sizes. */
/* Extra small screen / phone */
/* Deprecated `@screen-xs` as of v3.0.1 */
/* Deprecated `@screen-xs-min` as of v3.2.0 */
/* Deprecated `@screen-phone` as of v3.0.1 */
/* Deprecated `@screen-sm` as of v3.0.1 */
/* Deprecated `@screen-tablet` as of v3.0.1 */
/* Deprecated `@screen-md` as of v3.0.1 */
/* Deprecated `@screen-desktop` as of v3.0.1 */
/* Deprecated `@screen-lg` as of v3.0.1 */
/* Deprecated `@screen-lg-desktop` as of v3.0.1 */
/*== Grid system
//
//## Define your custom responsive grid. */
/* Number of columns in the grid. */
/* Padding between columns. Gets divided in half for the left and right. */
/* Point at which the navbar becomes uncollapsed. */
/* Point at which the navbar begins collapsing. */
/*== Container sizes
//
//## Define the maximum width of `.container` for different screen sizes. */
/* Small screen / tablet */
/* For `@screen-sm-min` and up. */
/* Medium screen / desktop */
/* For `@screen-md-min` and up. */
/* Large screen / wide desktop */
/* For `@screen-lg-min` and up. */
/*== Navbar
//
//## */
/* Basics of a navbar */
/*== Inverted navbar */
/*== Navs
//
//## */
/*== Shared nav styles */
/*== Tabs */
/*== Pills */
/*== Pagination
//
//## */
/*== Pager
//
//## */
/*== Jumbotron
//
//## */
/*== Form states and alerts
//
//## Define colors for form feedback states and, by default, alerts. */
/*== Tooltips
//
//## */
/* Tooltip max width */
/* Tooltip text color */
/* Tooltip background color */
/* Tooltip arrow width */
/* Tooltip arrow color */
/*== Popovers
//
//## */
/* Popover body background color */
/* Popover maximum width */
/* Popover border color */
/* Popover fallback border color */
/* Popover title background color */
/* Popover arrow width */
/* Popover arrow color */
/* Popover outer arrow width */
/* Popover outer arrow color */
/* Popover outer arrow fallback color */
/*== Labels
//
//## */
/* Default label background color */
/* Primary label background color */
/* Success label background color */
/* Info label background color */
/* Warning label background color */
/* Danger label background color */
/* Default label text color */
/* Default text color of a linked label */
/*== Modals
//
//## */
/* Padding applied to the modal body */
/* Padding applied to the modal title */
/* Modal title line-height */
/* Background color of modal content area */
/* Modal content border color */
/* Modal content border color **for IE8** */
/* Modal backdrop background color */
/* Modal backdrop opacity */
/* Modal header border color */
/* Modal footer border color */
/*== Alerts
//
//## Define alert colors, border radius, and padding. */
/*== Progress bars
//
//## */
/* Background color of the whole progress component */
/* Progress bar text color */
/* Variable for setting rounded corners on progress bar. */
/* Default progress bar color */
/* Success progress bar color */
/* Warning progress bar color */
/* Danger progress bar color */
/* Info progress bar color */
/*== List group
//
//## */
/* Background color on `.list-group-item` */
/* `.list-group-item` border color */
/* List group border radius */
/* Background color of single list items on hover */
/* Text color of active list items */
/* Background color of active list items */
/* Border color of active list elements */
/* Text color for content within active list items */
/* Text color of disabled list items */
/* Background color of disabled list items */
/* Text color for content within disabled list items */
/*== Panels
//
//## */
/* Border color for elements within panels */
/*== Thumbnails
//
//## */
/* Padding around the thumbnail image */
/* Thumbnail background color */
/* Thumbnail border color */
/* Thumbnail border radius */
/* Custom text color for thumbnail captions */
/* Padding around the thumbnail caption */
/*== Wells
//
//## */
/*== Badges
//
//## */
/* Linked badge text color on hover */
/* Badge text color in active nav link */
/* Badge background color in active nav link */
/*== Breadcrumbs
//
//##

@breadcrumb-padding-vertical:   8px;
@breadcrumb-padding-horizontal: 15px;
/* Breadcrumb background color */
/* Breadcrumb text color */
/* Text color of current page in the breadcrumb */
/* Textual separator for between breadcrumb elements */
/*== Carousel
//
//## */
/*== Close
//
//## */
/*== Code
//
//## */
/*== Type
//
//## */
/* Horizontal offset for forms and lists. */
/* Text muted color */
/* Abbreviations and acronyms border color */
/* Headings small color */
/* Blockquote small color */
/* Blockquote font size */
/* Blockquote border color */
/* Page header border color */
/* Width of horizontal description list titles */
/* Point at which .dl-horizontal becomes horizontal */
/* Horizontal line color. */
/* Tools */
/*    Main mixins    */
/* ICON FONT - DecathlonCube and iconfont*/
/* LOADING GIF */
/* Rate element
usage
  .star-rate(@width);
*/
/* Hide content visually, but keep them availbale for seo and screen reader */
/* FONT */
/* font-[stretch value]-[weight keyword]-[style value] */
/* LEGACY */
/**
 * ##Buttons
 * File : path/button.less TODO
 */
/**
 * ### Generic button
 * `.cta`
 *
 *     @example
 *     a.cta(href="#")|My button
 *
 */
/**
 * ### Colors
 * Color class available : `.grey` `.yellow`
 *
 *     @example
 *     a.cta(href="#")|My button
 *     a.cta.yellow(href="#")|My button
 *     a.cta.grey(href="#")|My button
 *
 */
/**
 * ### With icon
 * [See icons available](http://iconslink.com).
 *
 *     @example
 *     a.cta.cta-icon.left(href="#")|My button
 *       span.icon.icon-search
 *
 */
/**
 * ### Small size
 * Size class available : `.small`
 *
 *     @example
 *     a.cta.small(href="#")|My button
 *     a.cta.yellow.small(href="#")|My button
 *     a.cta.grey.small(href="#")|My button
 *
 */
/**
 * ### Arrow
 * Arrow class available : `.left` `.right`
 *
 *     @example
 *     a.cta.left(href="#")|My button
 *     a.cta.yellow.right(href="#")|My button
 *     a.cta.grey.right(href="#")|My button
 *
 */
/**
 * ### Others display
 * Class available : `.disabled`
 *
 *     @example
 *     a.cta.disabled(href="#")|My button
 *
 */
/*
 * I converted the SCSS mixin to LESS for the awesome coders like myself in response to a blog post on 37Signals - http://37signals.com/svn/posts/3271-easy-retina-ready-images-using-scss
 *
 * Update: 2014-08-04 - Updated a long-standing bug where retina images were shown no matter what in the first background-image property.
 *                    - Updated retina media query to be more reliable ()
 * Update: 2013-11-13 - Picked up another technique thanks to reading this post from Tyler Tate, auto-fill in the second filename for the retina image, http://tylertate.com/blog/2013/06/11/retina-images-using-media-queries-and-LESS-CSS.html
 * Update: 2013-04-16 - Have recently found a few use cases when using a retina pattern from Subtle Patterns on the <body>, this has come in handy
 * Update: 2013-04-05 - Some research in the Wordpress Core(http://core.trac.wordpress.org/ticket/22238#comment:5) was pointed out that some tests may be redundant (Thanks @kbav) so I've cleaned these up
 * Update: 2012-12-29 - Updated AGAIN to add MS IE10 declaration and fix wonky 'min--moz-' declaration which Mozilla engineers are aware of
 * Update: 2012-11-21 - Updated again based on information from an article I found, added dppx and changed opera ratio to target more devices (http://www.uifuel.com/hd-retina-display-media-queries/)
 * Update: 2012-11-17 - Updated based on Wordpress Core to target even more devices! Thanks @Wordpress <3 (http://core.trac.wordpress.org/changeset/22629)
 */
/**
 * ##Titles
 * File : path/texts.less
 */
/**
 * ### Title header
 * `.title-header`
 *
 *     @example
 *     h1.title-header|My title
 *
 */
/**
 * ### Title header variant
 * `.title-header-variant`
 *
 *     @example
 *     h1.title-header-variant|My title variant
 *
 */
/**
 * ### Title product
 * `.title-product`
 *
 *     @example
 *     h1.title-product|My title product
 *
 */
/**
 * ### Subtitle
 * `.title-subtitle`
 *
 *     @example
 *     h1.title-subtitle|My subtitle
 *
 */
/**
 * ### Mixin titlePage
 * `.titlePage(@size, @color, @spanColor)`
 *
 *     @example
 *     a.cta-link.upper(href="#")|My link
 *
 * Example :
 * `.titlePage(1em, @white, @black)`
 *
 */
@-webkit-keyframes zoomicon {
  from {
    opacity: 0;
    -webkit-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}
@keyframes zoomicon {
  from {
    opacity: 0;
    -webkit-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}
@-webkit-keyframes vibe {
  from {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  to {
    opacity: 0;
    -webkit-transform: scale(1.3, 1.3);
    -moz-transform: scale(1.3, 1.3);
    -ms-transform: scale(1.3, 1.3);
    transform: scale(1.3, 1.3);
  }
}
@keyframes vibe {
  from {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  to {
    opacity: 0;
    -webkit-transform: scale(1.3, 1.3);
    -moz-transform: scale(1.3, 1.3);
    -ms-transform: scale(1.3, 1.3);
    transform: scale(1.3, 1.3);
  }
}
nav {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  font-size: 1.3rem;
  color: #fff;
  text-transform: uppercase;
  background-color: #0082c3;
  background-size: 100%;
  background-repeat: no-repeat;
  transform: translate(0);
  font-family: Roboto-condensed, 'Arial Narrow', Roboto, 'Microsoft Yahei', '微软雅黑', SimSun, '宋体', sans-serif;
}
main {
  flex-grow: 1;
  flex-basis: 0;
  overflow: auto;
  padding-top: 6.6rem;
  padding-bottom: 2rem;
}
main > *:not(:first-child) {
  margin-top: 2rem;
}
.parent {
  overflow: hidden;
}
ul {
  padding-left: 0;
  z-index: 1;
}
a,
button {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  padding: 1.7rem 2.5rem 1.7rem 3.5rem;
  color: inherit;
}
a:focus,
button:focus {
  outline: 0.1rem dotted rgba(255, 255, 255, 0.8);
  outline-offset: -0.3rem;
}
a::before,
button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(90deg, rgba(0, 117, 175, 0), #0075af);
  opacity: 0;
  transition: opacity 0.2s;
}
a:hover::before,
button:hover::before,
a:focus::before,
button:focus::before {
  opacity: 1;
}
a > *,
button > * {
  position: relative;
}
span:not(.nav-icon):not(.logo) {
  flex-grow: 1;
}
button,
.button {
  font-size: 1.15em;
  text-align: left;
  text-transform: uppercase;
  background-color: transparent;
  border-width: 0;
}
.main-categories button,
.main-categories .button {
  font-weight: bold;
}
.nav-icon {
  height: 2.5rem;
  width: 2.5rem;
  min-width: 2.5rem;
  margin-left: 1rem;
}
svg {
  display: block;
  height: 100%;
  width: 100%;
}
.baseline {
  display: flex;
  align-items: center;
  padding: 1rem 2.5rem 1rem 3.5rem;
}
.logo {
  height: 2rem;
  max-width: 8rem;
  margin-right: 1rem;
}
@media (min-width: 801px) {
  nav {
    font-size: 1.4rem;
  }
  a,
  button,
  .baseline {
    padding-right: 3.5rem;
    padding-left: 4rem;
  }
}
</style>

<nav id="main-menu" class="js-background-lazy" data-background-image={backgroundSrc}>
  <main class:parent={displayedSubLevel}>

    <ul class="main-categories" role="menu" data-tnr-menu-main-panel-entry>
      <li>
        <button
          id="allSports"
          on:click={() => {
            displayedSubLevel = 'allSports';
          }}
          on:focus={closeSubMenu}
          aria-expanded={displayedSubLevel === 'allSports'}
          role="menuitem"
          data-tnr-all-sports-button
          data-tnr-menu-main-categories>
          <span>{MenuTitle}</span>
          <span class="nav-icon" role="presentation">
            <SvgIcon icon="arrow" />
          </span>
        </button>

        {#if displayedSubLevel == 'allSports'}
          <AllSports {json} {MenuTitle} bind:defaultSport on:closeSubMenu={closeSubMenu} />
        {/if}
      </li>

      <!-- Other Categories -->

      {#each json.FirstLevelCategories.contentItems as firstLevelCategorie, index}
        {#if firstLevelCategorie.category && firstLevelCategorie.category.displayName}
          <li>
            {#if firstLevelCategorie.category.childCategories.length}
              <button
                id="cat-0{index}"
                on:click={() => {
                  displayedSubLevel = firstLevelCategorie.category.repositoryId;
                }}
                on:focus={closeSubMenu}
                aria-expanded={displayedSubLevel === firstLevelCategorie.category.repositoryId}
                role="menuitem"
                data-type="main-category"
                data-tnr-menu-main-categories>
                <span>{firstLevelCategorie.category.displayName}</span>
                <span class="nav-icon" role="presentation">
                  <SvgIcon icon="arrow" />
                </span>
              </button>
              {#if displayedSubLevel == firstLevelCategorie.category.repositoryId}
                <SubLevel
                  on:closeSubMenu={closeSubMenu}
                  ariaLabelName="cat-0{index}"
                  category={firstLevelCategorie.category}
                  depthLevel={1} />
              {/if}
            {:else if firstLevelCategorie.category.categoryLinks && firstLevelCategorie.category.categoryLinks.overriddenUrl && firstLevelCategorie.category.displayName}
              <a
                class="button"
                href={firstLevelCategorie.category.categoryLinks.overriddenUrl}
                on:focus={closeSubMenu}
                role="menuitem"
                data-type="main-link"
                data-tnr-menu-main-categories>
                <span>{firstLevelCategorie.category.displayName}</span>
                <span class="nav-icon" role="presentation">
                  <SvgIcon icon="arrow" />
                </span>
              </a>
            {/if}
          </li>
        {:else if firstLevelCategorie.name && (firstLevelCategorie.linkUrl || (firstLevelCategorie.link && typeof firstLevelCategorie.link === 'string'))}
          <a
            class="button"
            href={firstLevelCategorie.linkUrl || firstLevelCategorie.link}
            on:focus={closeSubMenu}
            role="menuitem"
            data-type="main-link"
            data-tnr-menu-main-categories>

            <span>{firstLevelCategorie.name}</span>
            <span class="nav-icon" role="presentation">
              <SvgIcon icon="arrow" />
            </span>
          </a>
        {/if}
      {/each}
    </ul>

    {#if json.MenuLinks.contentItems.length}
      <ul role="menu">
        {#each json.MenuLinks.contentItems as menuLink}
          {#if menuLink['@type'] == 'HNC_CategoryMenuLink' && menuLink.linkUrl && menuLink.name}
            <li data-tnr-main-links>
              <a
                href={localizeUri(menuLink.linkUrl)}
                class="navigation__link"
                on:focus={closeSubMenu}
                role="menuitem"
                data-type="main-link">
                <span>{menuLink.name}</span>

                <span class="nav-icon" role="presentation">
                  <SvgIcon icon="arrow" />
                </span>
              </a>
            </li>
          {:else if menuLink['@type'] == 'HNC_StaticCategoryMenuItem' && menuLink.MenuStaticLinks && menuLink.MenuStaticLinks[0] && menuLink.MenuStaticLinks[0].link && menuLink.name}
            <li>
              <a
                href={localizeUri(menuLink.MenuStaticLinks[0].link)}
                target={getBoolean(menuLink.displaylinkInNewTab) ? '_blank' : ''}
                on:focus={closeSubMenu}
                role="menuitem"
                data-tnr-menu-main-links
                data-type="main-link">
                <span>{menuLink.name}</span>

                <span class="nav-icon" role="presentation">
                  <SvgIcon icon="arrow" />
                </span>
              </a>
            </li>
          {:else if menuLink.link && menuLink.name}
            <li>
              <a
                href={localizeUri(menuLink.link)}
                target={getBoolean(menuLink.displaylinkInNewTab) ? '_blank' : ''}
                on:focus={closeSubMenu}
                role="menuitem"
                data-tnr-menu-main-links
                data-type="main-link">
                <span>{menuLink.name}</span>
                <span class="nav-icon" role="presentation">
                  <SvgIcon icon="arrow" />
                </span>
              </a>
            </li>
          {/if}
        {/each}
      </ul>
    {/if}

    <div class="baseline">
      <span class="logo" role="presentation">
        <svg id="logo" viewBox="0 0 176 44">
          <path
            fill="currentColor"
            d="M140.28,21.82a6,6,0,0,1-6,6.32h0a6.23,6.23,0,0,1-6-6.32,6,6,0,0,1,12,0ZM18.78,15.54H16.47V28.32h2.34c4.45,0,6.56-2,6.56-6.41C25.37,17.83,23.06,15.54,18.78,15.54ZM71.1,25.16V20l-3,5.12ZM176,0V44H0V0ZM43.93,10.67H31v9.14h0a10.48,10.48,0,0,0-3.3-6.44c-2.48-2.23-5.12-2.71-8.9-2.71H10.65V33.29h8.93c3.35,0,5.59-.45,8.13-2.8A10.72,10.72,0,0,0,31,24.23v9H43.93v-5H36.81v-4.1H43V19.34H36.81v-3.7h7.12Zm32.66,0H70.5S63,23.42,62.28,24.56h0c-.85,1.35-2.71,3.49-5.52,3.45-4.58-.07-6.3-3.23-6.3-6.07a6.06,6.06,0,0,1,5.94-6.07C60.2,15.8,63,19.44,63,19.44l3-4.79a12.1,12.1,0,0,0-9.55-4.43,11.84,11.84,0,0,0-12,11.62A11.66,11.66,0,0,0,55.08,33.72a12.74,12.74,0,0,0,10.66-3.83s0,0,.19,0c1.69,0,3.37,0,5.06,0v3.39h5.6Zm16.07,0H77.8v5.41h4.53V33.29h5.81V16.07h4.52Zm18.82,0h-5.82v8.59h-6V10.67H93.86V33.29h5.82V24.64h6v8.65h5.82Zm53.89,0h-5.83V23.24L150.8,10.67h-5.26v7.7A11.9,11.9,0,0,0,126,13.53a11.31,11.31,0,0,0-3.48,8.22,12,12,0,0,0,1.78,6.54h-5.23V10.68h-5.79V33.29h12.57v-3a11.41,11.41,0,0,0,8.47,3.51,11.71,11.71,0,0,0,8.46-3.55,11.44,11.44,0,0,0,2.79-4.7v7.76h5.82V20.69l8.88,12.6h5.12Z" />
        </svg>
      </span>
      {i18n('navigation.40years')}
    </div>
  </main>

  <Footer {json} {storeInfos} />
</nav>



// WEBPACK FOOTER //
// ./src/commons/navigation/Navigation.svelte